import { memo } from "react";

type SwimLaneHeaderProps = {
  label: string;
};

const SwimLaneHeader = memo(({ label }: SwimLaneHeaderProps) => {
  return <div className="swim-headers flex jc-sb ai-c">{label}</div>;
});

SwimLaneHeader.displayName = "SwimLaneHeader";

export default SwimLaneHeader;
